import { QuestionBase } from "./question-base.model";

export class PullableQuestion extends QuestionBase<string> {
   controlType = 'pullable';
   id: string;
   getterKey = null;
   getterValue = null;
   flag: boolean;
   options: { key: string, value: string }[] = [];
   disabled: boolean;
   value: any;
   config = {};
   dropdownParent: any;
   pullableData: any;
   dropdownMyParent: any;
   conditions: any;
   visible: boolean;
   populate_field: boolean;
   req_keys: any;
   resource_add: boolean;
   defaultValue: any;
   formAutofill: any;
   format: any;
   default: any;
   view_key: any;
   bannerJson: any;
   pullable_response_array: any = [];
   complex_search: any = [];
   filter: any;
   fields: any = [];
   auto_pullable: boolean;

   constructor(options: {} = {}) {
      super(options);
      this.options = options['options'] || [];
      this.id = options['id'];
      this.getterKey = options['getterKey'] || null;
      this.getterValue = options['getterValue'] || null;
      this.disabled = (options['disabled'] == undefined) ? false : options['disabled'];
      this.flag = options['flag'] || false;
      this.config = options['config'] || null;
      this.value = options['default'] || '';
      this.pullableData = options['pullableData'] || {};
      this.conditions = options['conditions'];
      this.visible = (options['visible'] == undefined) ? true : options['visible'];
      this.populate_field = (options['populate_field'] == undefined) ? false : options['populate_field'];
      this.req_keys = options['req_keys'] || false;
      this.resource_add = (options['resource_add'] == undefined) ? false : options['resource_add'];
      this.defaultValue = options['defaultValue'];
      this.formAutofill = options['formAutofill'];
      this.format = options['format'];
      this.default = options['default'];
      this.view_key = options['view_key'] || false;
      this.bannerJson = options['bannerJson']
      this.pullable_response_array = options['pullable_response_array'] || [];
      this.complex_search = options['complex_search'] || []
      this.filter = options['filter'] ? options['filter'] : '';
      this.fields = options['fields'] || []//data grid fields for view form
      this.auto_pullable = options['auto_pullable'] || false;
   }
}
